const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100.353 100.353",
    style: {
      enableBackground: "new 0 0 100.353 100.353"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(255, 255, 255)"
    },
    d: "M54.354,58.447V11.574c0-5.292-4.305-9.598-9.596-9.598c-5.295,0-9.603,4.306-9.603,9.598v46.889 c-6.921,3.577-11.35,10.772-11.35,18.61c0,11.552,9.399,20.95,20.953,20.95c11.549,0,20.946-9.398,20.946-20.95 C65.704,69.169,61.298,62.022,54.354,58.447z M44.758,95.023c-9.899,0-17.953-8.052-17.953-17.95 c0-6.923,4.029-13.264,10.276-16.224c0.62-0.184,1.074-0.752,1.074-1.431V11.573c0-3.638,2.962-6.598,6.603-6.598 c3.637,0,6.596,2.959,6.596,6.598c0,0,0.066,46.861-0.027,47.083c-0.009,1.025,0.049,1.543,0.797,1.966 c0.109,0.046,0.213,0.102,0.321,0.15c0.095,0.059,0.197,0.105,0.305,0.142c6.297,2.952,9.954,9.159,9.954,16.158 C62.704,86.971,54.653,95.023,44.758,95.023z",
    id: "id_101"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(255, 255, 255)"
    },
    d: "M46.251,68.074V17.188c0-0.829-0.671-1.5-1.5-1.5s-1.5,0.671-1.5,1.5v50.886 c-4.74,0.727-8.386,4.822-8.386,9.764c0,5.454,4.435,9.89,9.886,9.89c5.456,0,9.894-4.437,9.894-9.89 C54.644,72.895,50.995,68.8,46.251,68.074z M44.751,84.728c-3.797,0-6.886-3.091-6.886-6.89s3.089-6.89,6.886-6.89 c3.801,0,6.894,3.091,6.894,6.89S48.552,84.728,44.751,84.728z",
    id: "id_102"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(255, 255, 255)"
    },
    d: "M59.16,17.77h15.536c0.829,0,1.5-0.671,1.5-1.5s-0.671-1.5-1.5-1.5H59.16 c-0.829,0-1.5,0.671-1.5,1.5S58.331,17.77,59.16,17.77z",
    id: "id_103"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(255, 255, 255)"
    },
    d: "M59.16,33.477h7.769c0.829,0,1.5-0.671,1.5-1.5s-0.671-1.5-1.5-1.5H59.16 c-0.829,0-1.5,0.671-1.5,1.5C57.66,32.806,58.331,33.477,59.16,33.477z",
    id: "id_104"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(255, 255, 255)"
    },
    d: "M74.696,47.467H59.16c-0.829,0-1.5,0.671-1.5,1.5s0.671,1.5,1.5,1.5h15.536 c0.829,0,1.5-0.671,1.5-1.5S75.525,47.467,74.696,47.467z",
    id: "id_105"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemp);
export default __webpack_public_path__ + "static/media/temp.90909e98e8c6f263be604b819ff0260e.svg";
export { ForwardRef as ReactComponent };